export default __webpack_public_path__ + "static/media/kyc-in-review-icon.db14c276.svg";